import { render, staticRenderFns } from "./Osobe.vue?vue&type=template&id=4208a2b8&scoped=true&"
import script from "./Osobe.vue?vue&type=script&lang=js&"
export * from "./Osobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208a2b8",
  null
  
)

export default component.exports